import { useMemo } from "react";

import { Ship } from "components/icons/generated";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useShipInfraGroup = (): MainNavigationItem => {
  return useMemo(
    () => ({
      id: "ship-infra",
      title: "Ship Infra",
      icon: Ship,
      items: [
        {
          items: [
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Stacks],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Resources],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Runs],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[
              MainNavigationPrimaryMenuItemKeys.TemplatesMarketplace
            ],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.IntentProjects],
          ],
        },
      ],
    }),
    []
  );
};

export default useShipInfraGroup;
